import { useRef, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { driverMethodCollectingRepository } from "../data/driverMethodCollectingRepository";
import { updateDriverMethodCollectingUseCase } from "../domain/updateDriverMethodCollectingUseCase";

export function EditDriverMethodCollectingModal({
  driver,
  method,
  onClose,
  onSaved,
}) {
  const [paymentValue, setPaymentValue] = useState(method.payment_value ?? "");
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const submitting = useRef(false);
  const exceedsLimit = Array.from(paymentValue).length > 50;

  async function handleSubmit(event) {
    event.preventDefault();
    if (submitting.current || exceedsLimit) return;
    submitting.current = true;
    setIsSaving(true);
    setError(null);
    const result = await updateDriverMethodCollectingUseCase(
      driverMethodCollectingRepository,
      driver.id,
      method,
      paymentValue,
    );
    submitting.current = false;
    setIsSaving(false);
    if (result.success) {
      onSaved(result.data);
    } else {
      setError(result.error);
    }
  }

  return (
    <Dialog
      open
      onClose={isSaving ? undefined : onClose}
      fullWidth
      maxWidth="xs"
      aria-labelledby="edit-driver-method-collecting-title"
    >
      <Box component="form" onSubmit={handleSubmit}>
        <DialogTitle id="edit-driver-method-collecting-title">
          Editar método de cobro
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ pt: 1 }}>
            <TextField
              label="Conductor"
              value={driver.fullname ?? ""}
              fullWidth
              InputProps={{ readOnly: true }}
            />
            <TextField
              label="Método de cobro"
              value={method.name}
              fullWidth
              InputProps={{ readOnly: true }}
            />
            <TextField
              autoFocus
              fullWidth
              label="Información de cobro"
              value={paymentValue}
              disabled={isSaving}
              error={exceedsLimit}
              helperText={
                exceedsLimit
                  ? "Reduce el valor a un máximo de 50 caracteres."
                  : "Máximo 50 caracteres. Dejar vacío limpia el valor."
              }
              onChange={(event) => setPaymentValue(event.target.value)}
            />
            {error && <Alert severity="error">{error}</Alert>}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={onClose} disabled={isSaving}>
            Cancelar
          </Button>
          <Button
            type="submit"
            color="secondary"
            variant="contained"
            disabled={isSaving || exceedsLimit}
          >
            {isSaving ? "Actualizando..." : "Actualizar"}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
